
import {UIWGameManager} from '../UIWGameManager'
import {UIGameHelpButtonsController} from '../../../../shared/scripts/ui_game/ui_game_help_buttons/UIGameHelpButtonsController'
import UIGameSpectatorDisplay from '../../../../shared/scripts/ui_game/ui_game_help_buttons/UIGameSpectatorDisplay'
import {UIWGameHelpButtons} from './UIWGameHelpButtons'

export class UIWGameHelpButtonsController extends UIGameHelpButtonsController {
    constructor(uiGameManager: UIWGameManager) {
        super(uiGameManager)
        this.view = new UIWGameHelpButtons(this.uiGameManager, this, this.uiGameManager.gameController.gameSettings)
        this.spectatorDisplay = new UIGameSpectatorDisplay(this.view.spectatorsContainer)
        this.view.resize()
    }
}
